import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as Arrow } from '../../images/icons/fs-lc-arrow.svg';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import SmartLink from '../Common/SmartLink';
import * as styles from './ProfileCard.module.css';
import ProfileImage from './ProfileImage';

const ProfileCard = (props) => {
  const { image, isSpark, accentColor } = props;
  const bgColors = { Grey: styles.grey, Pink: styles.pink, None: styles.none };

  return isSpark ? (
    <div className={styles.sparkCard}>
      <SmartLink to={`/spark/agenda/#${props.name.replace(' ', '')}`} style={{ display: 'block' }}>
        <ProfileImage image={image} isSpark={isSpark} />
      </SmartLink>
      <div className={[styles.content, bgColors[accentColor] || styles.pink].join(' ')}>
        <div>
          <b>{props.name}</b>
          <RichTextConverter copy={props.copy} />
        </div>
        <div className={styles.links}>
          <SmartLink to={`/spark/agenda/#${props.name.replace(' ', '')}`}>View Session</SmartLink>
          {props.link && (
            <>
              <div className={styles.divider} />
              <SmartLink to={props.link}>LinkedIn</SmartLink>
            </>
          )}
        </div>
      </div>
    </div>
  ) : (
    <SmartLink to={props.link} style={{ display: 'block' }}>
      <ProfileImage image={image} />
      <div className={[styles.content, bgColors[accentColor] || styles.pink].join(' ')}>
        <div>
          <b>{props.name}</b>
          <br />
          <RichTextConverter copy={props.copy} />
        </div>
        <Arrow className={styles.arrow} />
      </div>
    </SmartLink>
  );
};

ProfileCard.propTypes = {
  image: PropTypes.object.isRequired,
  copy: PropTypes.object.isRequired,
  link: PropTypes.string.isRequired,
};

export default ProfileCard;
